import { render, staticRenderFns } from "./LKI02.vue?vue&type=template&id=fdd082d2&scoped=true"
import script from "./LKI02.vue?vue&type=script&lang=js"
export * from "./LKI02.vue?vue&type=script&lang=js"
import style0 from "./LKI02.vue?vue&type=style&index=0&id=fdd082d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd082d2",
  null
  
)

export default component.exports